import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "dark", // Enables dark mode

    primary: {
      // Dynamic and powerful indigo (sense of trust, focus, and technology)
      main: "#5c6bc0ff", // Lighter indigo for better readability in dark mode
      light: "#8c9eff",
      dark: "#26418f",
      contrastText: "#FFFFFF",
    },

    secondary: {
      // Electric blue - sense of technology and precision
      main: "#00E5FF",
      light: "#6EFFFF",
      dark: "#00B2CC",
      contrastText: "#000000",
    },

    success: {
      // Neon green for workout success confirmation
      main: "#00E676",
      dark: "#00B248",
    },

    error: {
      // Bright red for severe warnings
      main: "#FF1744",
    },

    warning: {
      // Amber yellow
      main: "#FFC400",
    },

    info: {
      // Light icy blue
      main: "#80D8FF",
    },

    text: {
      primary: "#FFFFFF",
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.3)",
    },

    grey: {
      500: "#9E9E9E",
      800: "#2A2A2A", // For inner backgrounds
      900: "#121212", // Main matte black
    },

    background: {
      default: "#121212",
      paper: "#1E1E1E",
    },

    custom: {
      lowOpacity: "rgba(255, 255, 255, 0.05)",
      highOpacity: "rgba(30, 30, 30, 0.9)",
      contrast: "#0A0A0A",
    },
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 450,
      md: 600,
      lg: 900,
      xl: 1280,
      xxl: 1440,
      exl: 1920,
      tv: 2500,
    },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontSize: "12px",
          "@media (min-width:600px)": {
            fontSize: "14px",
          },
          "@media (min-width:1220px)": {
            fontSize: "16px",
          },
          "@media (min-width:1440px)": {
            fontSize: "18px",
          },
        },
        // Adding clean black scrollbar for dark mode consistency
        body: {
          "&::-webkit-scrollbar": {
            width: "8px",
            height: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#1E1E1E",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#5c6bc0ff", // Matching primary indigo color
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#8c9eff", // Matching primary light color
          },
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none", // Remove default light shadows
          borderRadius: 12, // More rounded corners for modern feel
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 30, // Capsule-shaped buttons for athletic feel
          textTransform: "none",
          fontWeight: 600,
          padding: "8px 24px",
        },
        containedPrimary: {
          // Indigo gradient for primary button (matching new primary color)
          background: "linear-gradient(45deg, #3f51b5 30%, #5c6bc0 90%)",
          "&:hover": {
            background: "linear-gradient(45deg, #303f9f 30%, #3f51b5 90%)",
            boxShadow: "0px 4px 20px rgba(63, 81, 181, 0.4)", // Indigo shadow
          },
        },
      },
    },
    MuiRating: {
      styleOverrides: {
        root: {
          direction: "ltr", // این خط کلاً مشکل برعکس پر شدن ستاره‌ها رو تو کل پروژه حل می‌کنه
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#1E1E1E",
          borderRadius: 16,
          border: "1px solid rgba(255, 255, 255, 0.05)",
        },
      },
    },

    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(18, 18, 18, 0.8)",
          backdropFilter: "blur(10px)",
          boxShadow: "none",
          borderBottom: "1px solid rgba(255, 255, 255, 0.05)",
        },
      },
    },
  },

  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h1: {
      fontWeight: 800,
      letterSpacing: "-0.5px",
    },
    h2: {
      fontWeight: 700,
    },
    button: {
      fontWeight: 600,
    },
  },
});

export default theme;
